// Firebaseとreactを連携させる記述
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyADDtYRll1QJIzuc7mloucHkSOBvpKa1bU",
  authDomain: "blog-2715c.firebaseapp.com",
  projectId: "blog-2715c",
  storageBucket: "blog-2715c.appspot.com",
  messagingSenderId: "582849586634",
  appId: "1:582849586634:web:ad65ae94775ea815485b33"
};

const app = initializeApp(firebaseConfig);
// 認証
const auth = getAuth(app);
// インスタンス化
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, provider, db };
